<template>
  <div class="min-h-screen h-screen bg-gray-100">
    <nav class="fixed top-0 left-0 w-full bg-white shadow-sm z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-12 sm:h-16">
          <div class="flex items-center">
            <div class="flex-shrink-0 flex items-center">
              <a :href="route('control-panel.index')">
                <img
                  class="block sm:hidden h-8 sm:h-10 w-auto sharp-image"
                  src="/img/brandpreneurship.svg"
                  alt="brandpreneurship"
                />
                <img
                  class="hidden sm:block h-8 sm:h-10 w-auto sharp-image"
                  src="/img/brandpreneurship.svg"
                  alt="brandpreneurship"
                />
              </a>
            </div>
            <div class="ml-6 flex-col sm:mt-1">
              <p class="text-lg sm:text-xl font-light"></p>
            </div>
          </div>

          <simple-profile v-if="showProfile"></simple-profile>
        </div>
      </div>
    </nav>

    <div class="py-1 h-full">
      <main class="h-full">
        <div class="max-w-7xl h-full mx-auto sm:px-6 lg:px-8 pt-12">
          <!-- Main: start -->

          <slot></slot>

          <!-- Main: end -->
        </div>
      </main>
    </div>
  </div>
</template>

<script>
// import Profile from '@/Pages/ControlPanel/Shared/Profile';
import SimpleProfile from '@/Pages/ControlPanel/Shared/SimpleProfile';

export default {
  components: { SimpleProfile },

  props: {
    showProfile: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
};
</script>
